export default "__VITE_ASSET__a7b46a7b__"